module.exports = __webpack_public_path__ + "assets/img/6.7a815005.png";